import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface LogoLinksSearchStyles {
    container: InjectableCss;
    logoWrapper: InjectableCss;
    searchMenuWrapper: InjectableCss;
    linkListHidden: HiddenProps;
    // Verndale Customization: Add user option to add image next to logo
    logoGridContainer?: GridContainerProps;
    logoGridItem?: GridItemProps;
    imageGridItem?: GridItemProps;
    imageGridItem2?: GridItemProps;
    countrySelectorGridItem?: GridItemProps;
}

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    container: {
        css: css`
            display: flex;
            justify-content: space-between;
        `,
    },
    logoWrapper: {
        css: css`
            text-align: left;
            padding: 20px 45px;
            margin: 0 24px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            flex-grow: 1;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
            img {
                height: 78px;
                ${({ theme }) => {
                    return breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                height: 42px;
                                width: auto;
                                margin: 0;
                            `,
                            null,
                            null,
                        ],
                        "max",
                    );
                }}
            }
        `,
    },
    searchMenuWrapper: {
        css: css`
            text-align: right;
            padding: 20px 45px;
            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            display: none;
                        `,
                        css`
                            flex-grow: 8;
                        `,
                        null,
                        null,
                    ],
                    "max",
                );
            }}
        `,
    },
    linkListHidden: {
        below: "lg",
    },
    logoGridContainer: {
        css: css`
            @media (max-width: 768px) {
                flex-wrap: nowrap !important;
            }
        `,
    },
    imageGridItem2: {
        css: css`
            flex: 1 1 auto;
            padding: 0;
            width: auto;
            max-width: max-content;
            padding-inline-end: 10px;
        `,
    },
};

const LogoLinksSearch: React.FC<PageProps> = ({ id }) => (
    <StyledWrapper {...logoLinksSearchStyles.container}>
        <StyledWrapper {...logoLinksSearchStyles.logoWrapper}>
            {/* ****** Verndale Customization: Add user option to add image next to logo */}
            <GridContainer
                {...logoLinksSearchStyles.logoGridContainer}
                offsetCss={css`
                    @media (max-width: 768px) {
                        flex-wrap: nowrap !important;
                    }
                `}
            >
                <GridItem {...logoLinksSearchStyles.logoGridItem} className="logo-item">
                    <Zone contentId={id} zoneName="Logo" fixed />
                </GridItem>
                <GridItem {...logoLinksSearchStyles.imageGridItem2} className="logo-item logo-item--2">
                    <Zone contentId={id} zoneName="Image" />
                </GridItem>
                <GridItem {...logoLinksSearchStyles.imageGridItem} className="logo-item logo-item--3">
                    <Zone contentId={id} zoneName="Image2" />
                </GridItem>
                <GridItem {...logoLinksSearchStyles.countrySelectorGridItem} className="country-selector-container">
                    <Zone contentId={id} zoneName="CountrySelector" />
                </GridItem>
            </GridContainer>
            {/* *************** */}
        </StyledWrapper>
        <StyledWrapper {...logoLinksSearchStyles.searchMenuWrapper}>
            <Hidden {...logoLinksSearchStyles.linkListHidden}>
                <Zone contentId={id} zoneName="LinkList" fixed />
            </Hidden>
            {/* Verndale Customization: Remove Search from this area, since it will show on the Main Navigation (Header Page) */}
            {/* <Zone contentId={id} zoneName="Search" fixed /> */}
            {/* *************** */}
        </StyledWrapper>
    </StyledWrapper>
);

const logoLinksSearch: WidgetModule = {
    component: LogoLinksSearch,
    definition: {
        group: "Common",
        icon: "magnifying-glass",
    },
};

export default logoLinksSearch;
